import { render, staticRenderFns } from "./compAddAccount.vue?vue&type=template&id=1e6a387f&scoped=true&"
import script from "./compAddAccount.vue?vue&type=script&lang=js&"
export * from "./compAddAccount.vue?vue&type=script&lang=js&"
import style0 from "./compAddAccount.vue?vue&type=style&index=0&id=1e6a387f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6a387f",
  null
  
)

export default component.exports